import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@creditas/button'

import { ProfileTypes } from 'types/enums'
import { useGetNextClient } from 'hooks/useGetNextClient'
import { useTriage } from 'hooks/useTriage'

type Props = {
  profileType: ProfileTypes
}

export const NextClientButton: FC<Props> = ({ profileType }) => {
  const { t } = useTranslation(['formalization'])
  const { data } = useTriage('formalization', profileType)
  const { get, loading } = useGetNextClient(profileType)

  const isConsultant = profileType === ProfileTypes.Consultant
  const hasPendingCustomer = data && data.length > 0
  const cannotGetNextCustomer = isConsultant && hasPendingCustomer

  return (
    <Button
      onClick={get}
      isLoading={loading}
      disabled={loading || cannotGetNextCustomer}
      css={{ minWidth: 'initial' }}
    >
      {t('add-customer')}
    </Button>
  )
}
